// Code generated by tygo. DO NOT EDIT.
import * as dbmodels from '@/interface/gen/dbmodels.ts';
//////////
// source: artifact.sql.go

export interface AddArtifactParams {
  cv_id: number /* int32 */;
  s3_file_id: string;
  file_name: string;
  type: ArtifactType;
}
export interface GetArtifactForUserParams {
  id: number /* int32 */;
  user_id: number /* int32 */;
}
export interface ListArtifactsParams {
  cv_id: number /* int32 */;
  user_id: number /* int32 */;
  type: ArtifactType;
}
export interface ListArtifactsRow {
  id: number /* int32 */;
  file_name: string;
  type: ArtifactType;
}

//////////
// source: company.sql.go

export interface AddCompanyParams {
  external_id: number /* int32 */;
  title: string;
  data: dbmodels.CompanyData;
}

//////////
// source: cv.sql.go

export interface GetCVListByVacancyIDsParams {
  user_id: number /* int32 */;
  vacancy_ids: number /* int32 */[];
}
export interface GetCvByIDForUserParams {
  id: number /* int32 */;
  user_id: number /* int32 */;
}
export interface SetCvArtifactTypesParams {
  artifacts: ArtifactType[];
  id: number /* int32 */;
}
export interface SetCvDedupStateParams {
  dedup_state: DedupStateType;
  id: number /* int32 */;
}
export interface SetCvHasComentParams {
  has_comment: boolean;
  id: number /* int32 */;
}
export interface SetCvProfileStatusByExternalCvIDParams {
  profile_status: CvProfileStatus;
  external_cv_id: number;
}
export interface SetExternalCvIDParams {
  external_cv_id: number;
  id: number /* int32 */;
}
export interface UpsertCVParams {
  vacancy_id: number /* int32 */;
  user_id: number /* int32 */;
  s3_file_id: string;
  last_name: string;
  first_name: string;
  middle_name: string;
  position: string;
}

//////////
// source: cv_comment.sql.go

export interface AddCvCommentParams {
  cv_id: number /* int32 */;
  value: string;
}
export interface GetCvCommentForUserParams {
  cv_id: number /* int32 */;
  user_id: number /* int32 */;
}

//////////
// source: db.go

export type DBTX = any;
export interface Queries {
}

//////////
// source: models.go

export enum ArtifactType {
  Audio = "audio",
  Video = "video",
}
export interface NullArtifactType {
  artifact_type: ArtifactType;
  valid: boolean; // Valid is true if ArtifactType is not NULL
}
export enum CvProfileStatus {
  IsInitialNotSuitable = "is_initial_not_suitable",
  ReviewerNotSuitable = "reviewer_not_suitable",
  ReviewerDiscarded = "reviewer_discarded",
  RecruiterDiscarded = "recruiter_discarded",
  Draft = "draft",
  IsInitial = "is_initial",
  InTheWork = "in_the_work",
  ServicePrepareQa = "service_prepare_qa",
  ServicePrepare = "service_prepare",
  StandardProfileClientSend = "standard_profile_client_send",
  StandardProfileClientConfirmed = "standard_profile_client_confirmed",
  PhoneInterviewTimeConfirmed = "phone_interview_time_confirmed",
  PhoneInterviewDone = "phone_interview_done",
  InterviewTimeConfirmed = "interview_time_confirmed",
  InterviewDone = "interview_done",
  QualityControlStart = "quality_control_start",
  QualityControlDone = "quality_control_done",
  ProfileSend = "profile_send",
  OnClientCofirmation = "on_client_cofirmation",
  ClientConfirmed = "client_confirmed",
  ClientDiscarded = "client_discarded",
  InReview = "in_review",
  FinalInterviewAssigned = "final_interview_assigned",
  FinalInterview = "final_interview",
  Approved = "approved",
  ApplicantCheckStart = "applicant_check_start",
  ApplicantCheckPassed = "applicant_check_passed",
  ApplicantTestingStart = "applicant_testing_start",
  ApplicantTestingPassed = "applicant_testing_passed",
  ClientFeedbackDateConfirmed = "client_feedback_date_confirmed",
  ClientFeedbackDone = "client_feedback_done",
  PersonalMeetingAssigned = "personal_meeting_assigned",
  PersonalMeetingDone = "personal_meeting_done",
  OfferGranted = "offer_granted",
  OfferAccepted = "offer_accepted",
  StartWorkDateConfirmed = "start_work_date_confirmed",
  ApplicantStartedToWork = "applicant_started_to_work",
  IntershipDateConfirmed = "intership_date_confirmed",
  OnTestingPeriod = "on_testing_period",
  IntershipStarted = "intership_started",
  IntershipDone = "intership_done",
  EmployedDateConfirmed = "employed_date_confirmed",
  ApplicantEmployed = "applicant_employed",
  EmploymentDone = "employment_done",
  MoneyReceived = "money_received",
  EmploymentDocumentSigned = "employment_document_signed",
  ApplicantFeedbackDateConfirmed = "applicant_feedback_date_confirmed",
  ApplicantFeedbackDone = "applicant_feedback_done",
  WarrantyPeriodSheduled = "warranty_period_sheduled",
  WarrantyPeriodStart = "warranty_period_start",
  WarrantyPeriodDone = "warranty_period_done",
  WarrantyDocumentSigned = "warranty_document_signed",
}
export interface NullCvProfileStatus {
  cv_profile_status: CvProfileStatus;
  valid: boolean; // Valid is true if CvProfileStatus is not NULL
}
export enum DedupStateType {
  Pending = "pending",
  Accepted = "accepted",
  Declined = "declined",
}
export interface NullDedupStateType {
  dedup_state_type: DedupStateType;
  valid: boolean; // Valid is true if DedupStateType is not NULL
}
export enum UserRoles {
  Admin = "admin",
  Recruiter = "recruiter",
}
export interface NullUserRoles {
  user_roles: UserRoles;
  valid: boolean; // Valid is true if UserRoles is not NULL
}
export enum VacancyAssignmentState {
  Await = "await",
  Accepted = "accepted",
  UserDeclined = "user_declined",
  SystemDeclined = "system_declined",
}
export interface NullVacancyAssignmentState {
  vacancy_assignment_state: VacancyAssignmentState;
  valid: boolean; // Valid is true if VacancyAssignmentState is not NULL
}
export interface Artifact {
  id: number /* int32 */;
  cv_id: number /* int32 */;
  s3_file_id: string;
  file_name: string;
  type: ArtifactType;
  created_at: string /* RFC3339 */;
}
export interface Company {
  id: number /* int32 */;
  external_id: number /* int32 */;
  title: string;
  data: dbmodels.CompanyData;
  created_at: string /* RFC3339 */;
  updated_at: string /* RFC3339 */;
}
export interface Cv {
  external_cv_id: number;
  vacancy_id: number /* int32 */;
  s3_file_id: string;
  last_name: string;
  first_name: string;
  middle_name: string;
  position: string;
  created_at: string /* RFC3339 */;
  updated_at: string /* RFC3339 */;
  user_id: number /* int32 */;
  id: number /* int32 */;
  dedup_state: DedupStateType;
  artifacts: ArtifactType[];
  has_comment: boolean;
  profile_status: CvProfileStatus;
}
export interface CvComment {
  id: number /* int32 */;
  cv_id: number /* int32 */;
  value: string;
  created_at: string /* RFC3339 */;
}
export interface User {
  id: number /* int32 */;
  name: string;
  email: string;
  password: string;
  created_at: string /* RFC3339 */;
  roles: UserRoles[];
}
export interface UserContact {
  user_id: number /* int32 */;
  value: string;
}
export interface Vacancy {
  id: number /* int32 */;
  external_id: number /* int32 */;
  title: string;
  company_id: number /* int32 */;
  data: dbmodels.VacancyData;
  created_at: string /* RFC3339 */;
  updated_at: string /* RFC3339 */;
}
export interface VacancyAssignment {
  id: number /* int32 */;
  user_id: number /* int32 */;
  vacancy_id: number /* int32 */;
  is_latest: boolean;
  state: VacancyAssignmentState;
  created_at: string /* RFC3339 */;
}
export interface VideoTracker {
  id: number /* int64 */;
  user_id: number /* int32 */;
  video_hash: string;
  created_at: string /* RFC3339 */;
  start_at: number /* int32 */;
  end_at: number /* int32 */;
}
export interface VideoTrackerHeatmap {
  id: number /* int64 */;
  video_hash: string;
  updated_at: string /* RFC3339 */;
  checksum: number /* int32 */;
  heatmap: number /* int32 */[];
}

//////////
// source: users.sql.go

export interface AddUserWithCredentialsParams {
  email: string;
  password: string;
  roles: UserRoles[];
}
export interface CheckCredentialsParams {
  email: string;
  password: string;
}
export interface ResetUserPasswordByEmailParams {
  email: string;
  password: string;
}
export interface ResetUserPasswordByEmailRow {
  id: number /* int32 */;
  email: string;
}
export interface SetUserContactParams {
  user_id: number /* int32 */;
  value: string;
}
export interface SetUserNameParams {
  id: number /* int32 */;
  name: string;
}
export interface UsersListParams {
  offset: number /* int32 */;
  limit: number /* int32 */;
  id: number;
  email: null | string;
}
export interface UsersListRow {
  id: number /* int32 */;
  created_at: string /* RFC3339 */;
  email: string;
  has_contact: any;
}
export interface UsersListTotalParams {
  id: number;
  email: null | string;
}

//////////
// source: vacancy.sql.go

export interface AddVacancyParams {
  external_id: number /* int32 */;
  title: string;
  company_id: number /* int32 */;
  data: dbmodels.VacancyData;
}
export interface AddVacancyAssigmentStateParams {
  vacancy_id: number /* int32 */;
  user_id: number /* int32 */;
  state: VacancyAssignmentState;
}
export interface GetVacancyDataParams {
  user_id: number /* int32 */;
  id: number /* int32 */;
}
export interface GetVacancyDataRow {
  vacancy_title: string;
  company_title: string;
  vacancy_data: dbmodels.VacancyData;
  company_data: dbmodels.CompanyData;
  vacancy_created_at: string /* RFC3339 */;
}
export interface GetVacancyListParams {
  user_id: number /* int32 */;
  offset: number /* int32 */;
  limit: number /* int32 */;
}
export interface GetVacancyListRow {
  id: number /* int32 */;
  vacancy_title: string;
  company_title: string;
  state: VacancyAssignmentState;
  created_at: string /* RFC3339 */;
}
export interface ResetLatestVacancyAssigmentParams {
  vacancy_id: number /* int32 */;
  user_id: number /* int32 */;
}

//////////
// source: video_tracker.sql.go

export interface CreateVideoTrackerParams {
  user_id: number /* int32 */;
  video_hash: string;
  start_at: number /* int32 */;
  end_at: number /* int32 */;
}
export interface GetVideoStatViewsRow {
  count: number /* int64 */;
  video_hash: string;
}
export interface UpdateVideoHeatMapParams {
  heatmap: number /* int32 */[];
  new_checksum: number /* int32 */;
  video_hash: string;
  old_checksum: number /* int32 */;
}
